<template>
	<div class="row">
		<div class="col-md-4 mb-3">
			<div class="card">
				<div class="card-header">
					<p class="card-titile mb-0 text-muted font-weight-bold">Mural informativo</p>
				</div>
				<div class="card-body" v-if="hasAdmin">
					<div class="mb-2">
						<div class="media">
							<img src="https://crmeasysale.com/demo/images/icons/boy.png" class="mr-3 rounded-circle" alt="Usuario" width="30px" height="30px">
							<div class="media-body">
								<textarea v-model="form.descripcion" class="form-control border-0" placeholder="Ingrese su publicación" rows="3" :disabled="loading" style="resize: none;"></textarea>
							</div>
						</div>
						<img :src="form.image" class="img-fluid" v-if="form.image">
					</div>
					<div class="d-flex justify-content-between justify-content-center">
						<div class="d-flex align-items-center">
							<select v-model="form.tipo" class="custom-select mr-2" :disabled="loading" v-if="hasPrestamos" ng-if="hasPrestamos">
								<option v-for="tipo in tipos" :value="tipo.codigo">{{tipo.descripcion}}</option>
							</select>
							<button :class="{'btn btn-sm':true, 'btn-link':!validateFechas, 'btn-primary':validateFechas}" v-on:click="openProgramacion()" :disabled="loading">
								<span class="material-icons">date_range</span>
							</button>
							<button :class="{'btn btn-link btn-sm':true}" v-on:click="loadFile" :disabled="loading">
								<span class="material-icons">attach_file</span>
							</button>
							<input type="file" name="file" accept="image/*" class="d-none" ref="file" v-on:change="onFileChange">
						</div>
						<button class="btn btn-primary" :disabled="loading || disabled" style="border-radius: 50rem !important;" v-on:click="store()">
							Publicar
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-8 mb-3">
			<div class="list-group" v-if="publicacionesDisp.length>0">
				<div :class="{'list-group-item':true, 'bg-light':publicacion.ESTATUS==0}" v-for="publicacion in publicacionesDisp">
					<div v-if="formEdit.codigo == publicacion.CODIGO_PUBLICACION">
						<div class="mb-2">
							<div class="media">
								<img src="https://crmeasysale.com/demo/images/icons/boy.png" class="mr-3 rounded-circle" alt="Usuario" width="30px" height="30px">
								<div class="media-body">
									<textarea v-model="formEdit.descripcion" class="form-control border-0" placeholder="Ingrese su publicación" rows="3" :disabled="formEdit.loading" style="resize: none;"></textarea>
								</div>
							</div>
							<div class="row justify-content-center">
								<div class="col-md-6">
									<img :src="form.image" class="img-fluid" v-if="form.image">
								</div>
							</div>
						</div>
						<div class="d-flex justify-content-between justify-content-center">
							<div class="d-flex align-items-center">
								<select v-model="formEdit.tipo" class="custom-select mr-2" :disabled="formEdit.loading" v-if="hasPrestamos">
									<option v-for="tipo in tipos" :value="tipo.codigo">{{tipo.descripcion}}</option>
								</select>
								<button :class="{'btn btn-sm':true, 'btn-link':!validateFechasEdit, 'btn-primary':validateFechasEdit}" v-on:click="openProgramacion(true)" :disabled="formEdit.loading">
									<span class="material-icons">date_range</span>
								</button>
								<button :class="{'btn btn-link btn-sm':true}" v-on:click="loadFileEdit" :disabled="formEdit.loading">
									<span class="material-icons">attach_file</span>
								</button>
								<input type="file" name="fileEdit" accept="image/*" class="d-none" ref="fileEdit" v-on:change="onFileChangeEdit">
							</div>
							<button class="btn btn-primary" :disabled="formEdit.loading || formEdit.disabled" style="border-radius: 50rem !important;" v-on:click="update()">
								Actualizar
							</button>
						</div>
					</div>
					<div v-else>
						<div class="d-flex w-100 justify-content-between mb-2">
							<div>
								<small class="text-muted"><timeago :datetime="publicacion.FECHA_CREACION" :auto-update="30"></timeago></small>
								<span v-if="publicacion.ESTATUS==0">
									<small class="font-weight-bold">(publicación desactivada)</small>
								</span>
							</div>
							<div class="btn-group" v-if="hasAdmin">
								<button type="button" class="btn btn-link btn-sm dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<span class="material-icons">keyboard_arrow_down</span>
								</button>
								<div class="dropdown-menu dropdown-menu-right">
									<button class="dropdown-item" type="button" v-on:click="destroy(publicacion.CODIGO_PUBLICACION)">Eliminar</button>
									<button class="dropdown-item" type="button" v-on:click="cambiarEstado(publicacion.CODIGO_PUBLICACION, 1)" v-if="publicacion.ESTATUS == 0">
										Activar
									</button>
									<button class="dropdown-item" type="button" v-on:click="cambiarEstado(publicacion.CODIGO_PUBLICACION, 0)" v-else>
										Desactivar
									</button>
									<button class="dropdown-item" type="button" v-on:click="editarPublicacion(publicacion)" v-if="publicacion.ESTATUS==1">Editar</button>
								</div>
							</div>
						</div>
						<p v-html="urlify(publicacion.DESCRIPCION_PUBLICACION)" :class="{'publicacion-text mb-0':true, 'text-muted':publicacion.ESTATUS==0}"></p>
						<div class="row justify-content-center">
							<div class="col-md-6">
								<img :src="publicacion.IMG_URL" class="img-fluid" v-if="publicacion.IMG_URL">
							</div>
						</div>
						<div class="d-flex justify-content-end" v-if="hasAdmin">
							<small :class="{'badge mr-2':true, 'badge-primary':publicacion.ESTATUS!=0, 'bg-light':publicacion.ESTATUS==0}" v-if="publicacion.FECHA_INI">
								{{publicacion.FECHA_INI}}
							</small>
							<small :class="{'badge mr-2':true, 'badge-primary':publicacion.ESTATUS!=0, 'bg-light':publicacion.ESTATUS==0}" v-if="publicacion.FECHA_FIN">
								{{publicacion.FECHA_FIN}}
							</small>
							<small :class="{'badge mr-2':true, 'badge-primary':publicacion.ESTATUS!=0, 'bg-light':publicacion.ESTATUS==0}" v-if="publicacion.TIPO">
								{{getTipoDescripcion(publicacion.TIPO)}}
							</small>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="card rounded-fill overflow-hidden">
					<div class="card-body text-center">
						<h5 class="text-muted">No tiene publicaciones disponibles</h5>
					</div>
				</div>
			</div>

			<infinite-loading @infinite="infiniteHandler" ref="InfiniteLoading"></infinite-loading>
		</div>
		<div class="modal fade" id="programacionPublicacion" tabindex="-1" aria-labelledby="programacionPublicacionLabel" aria-hidden="true" v-if="hasAdmin">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="programacionPublicacionLabel">Programación</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="fecha_inicial">Fecha inicial</label>
							<date-picker id="fecha_inicial" placeholder="Fecha inicial" v-model="fecha_inicial"></date-picker>
						</div>
						<div class="form-group">
							<label for="fecha_final">Fecha final</label>
							<date-picker id="fecha_final" placeholder="Fecha inicial" v-model="fecha_final"></date-picker>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" v-on:click="confirmarFechas()">Confirmar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				publicaciones: [],
				form: {
					descripcion: '',
					tipo: 1,
					fecha_inicial: '',
					fecha_final: '',
					file: '',
					image: ''
				},
				formEdit: {
					codigo:'',
					tipo: '',
					descripcion: '',
					fecha_inicial: '',
					fecha_final: '',
					estado: '',
					file: '',
					image: '',
					disabled: true,
					loading: false
				},
				tipos: [
					{
						codigo: 1,
						descripcion: 'Vendedores'
					},
					{
						codigo: 2,
						descripcion: 'Aviso portal'
					},
					{
						codigo: 4,
						descripcion: 'Aviso portal (Solo inversores)'
					},
					{
						codigo: 5,
						descripcion: 'Aviso portal (Solo prestatarios)'
					},
					{
						codigo: 3,
						descripcion: 'Todos'
					},
				],
				loading: false,
				disabled: true,

				fecha_inicial:'',
				fecha_final:'',
				modalEdit: false
			}
		},

		methods: {
			loadFile(){
				this.$refs.file.click();
			},

			onFileChange(e) {
		    	var file = e.target.files || e.dataTransfer.files;
		    	this.form.file = this.$refs.file.files[0];
		    	
		    	if (!this.form.file)
		    		return;
		    	this.createImage(file[0])
		    },

		    loadFileEdit(){
				this.$refs.fileEdit.click();
			},

			onFileChangeEdit(e) {
		    	var file = e.target.files || e.dataTransfer.files;
		    	this.formEdit.file = this.$refs.fileEdit.files[0];
		    	
		    	if (!this.formEdit.file)
		    		return;
		    	this.createImageEdit(file[0])
		    },

		    createImageEdit(file) {
		    	var image = new Image();
		    	var reader = new FileReader();
		    	var vm = this;

		    	reader.onload = (e) => {
		    		vm.formEdit.image = e.target.result;
		     	};
		    	reader.readAsDataURL(file);
		    },

		    createImage(file) {
		    	var image = new Image();
		    	var reader = new FileReader();
		    	var vm = this;

		    	reader.onload = (e) => {
		    		vm.form.image = e.target.result;
		     	};
		    	reader.readAsDataURL(file);
		    },

			urlify(text){
				var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
				//var urlRegex = /(https?:\/\/[^\s]+)/g;
				return text.replace(urlRegex, function(url,b,c) {
					var url2 = (c == 'www.') ?  'http://' +url : url;
					return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
					//return '<a href="' + url + '" target="_blank">' + url + '</a>';
				})
			},

			openProgramacion(edit=false){
				if (edit) {
					this.fecha_inicial = this.formEdit.fecha_inicial
					this.fecha_final = this.formEdit.fecha_final
				}else{
					this.fecha_inicial = this.form.fecha_inicial
					this.fecha_final = this.form.fecha_final
				}
				this.modalEdit = edit
				$("#programacionPublicacion").modal('show')
			},

			confirmarFechas(){
				if (this.modalEdit) {
					this.formEdit.fecha_inicial = this.fecha_inicial
					this.formEdit.fecha_final = this.fecha_final
				}else{
					this.form.fecha_inicial = this.fecha_inicial
					this.form.fecha_final = this.fecha_final
				}
				$("#programacionPublicacion").modal('hide')
			},

			getTipoDescripcion(val){
				var it = this.tipos.filter(x => x.codigo == val)
				return (it[0] || []).descripcion
			},

			store(){
				this.loading = true
				let formData = new FormData();
	            formData.append('descripcion', this.form.descripcion);
	            formData.append('tipo', this.form.tipo);
	            formData.append('fecha_inicial', this.form.fecha_inicial);
	            formData.append('fecha_final', this.form.fecha_final);
	            formData.append('file', this.form.file);
				
				axios.post('/api/publicaciones', formData, {
                	headers: {
                    	'Content-Type': 'multipart/form-data'
                	}
	            }).then((res)=>{
					this.$refs.InfiniteLoading.stateChanger.reset()
					this.clearFields()
					this.$toasted.show('La publicación ha sido agregada.')
				}).catch((err) =>{
					console.log(err.response)
					this.$toasted.show('Error al agregar la publicación.')
				}).then(() => {
					this.loading = false
				})
			},

			update(){
				this.formEdit.loading = true
				axios.put(`/api/publicaciones/${this.formEdit.codigo}`, this.formEdit).then((res)=>{
					var index = this.publicaciones.data.findIndex(x=> x.CODIGO_PUBLICACION == this.formEdit.codigo)
					this.publicaciones.data.splice(index, 1, {
		                CODIGO_PUBLICACION: res.data.CODIGO_PUBLICACION,
		                DESCRIPCION_PUBLICACION: res.data.DESCRIPCION_PUBLICACION,
		                FECHA_INI: res.data.FECHA_INI,
		                FECHA_FIN: res.data.FECHA_FIN,
		                ESTATUS: res.data.ESTATUS,
		                TIPO: res.data.TIPO,
		                FECHA_CREACION: res.data.FECHA_CREACION,
		                FECHA_ACTUALIZACION: res.data.FECHA_ACTUALIZACION,
		                CREADO_POR: res.data.CREADO_POR,
		                ACTUALIZADO_POR: res.data.ACTUALIZADO_POR,
		                CREADO_DESDE: res.data.CREADO_DESDE,
		                ACTUALIZADO_DESDE: res.data.ACTUALIZADO_DESDE,
		                FECHA_ELIMINACION: res.data.FECHA_ELIMINACION,
		            })
		            this.clearFields()
		            this.$toasted.show('La publicación ha sido actualizada.')
				}).catch((err) =>{
					//
				}).then(() => {
					this.formEdit.loading = false
				})
			},

			destroy(id){
				axios.delete(`/api/publicaciones/${id}`).then((res)=>{
					this.$refs.InfiniteLoading.stateChanger.reset()
					this.$toasted.show('La publicación ha sido eliminada.')
				}).catch((err) =>{
					//
				})
			},

			cambiarEstado(id, estado){
				axios.put(`/api/publicaciones/${id}`,{
					estado: estado
				}).then((res)=>{
					var index = this.publicaciones.data.findIndex(x=> x.CODIGO_PUBLICACION == id)
					this.publicaciones.data.splice(index, 1, {
		                CODIGO_PUBLICACION: res.data.CODIGO_PUBLICACION,
		                DESCRIPCION_PUBLICACION: res.data.DESCRIPCION_PUBLICACION,
		                FECHA_INI: res.data.FECHA_INI,
		                FECHA_FIN: res.data.FECHA_FIN,
		                ESTATUS: res.data.ESTATUS,
		                TIPO: res.data.TIPO,
		                FECHA_CREACION: res.data.FECHA_CREACION,
		                FECHA_ACTUALIZACION: res.data.FECHA_ACTUALIZACION,
		                CREADO_POR: res.data.CREADO_POR,
		                ACTUALIZADO_POR: res.data.ACTUALIZADO_POR,
		                CREADO_DESDE: res.data.CREADO_DESDE,
		                ACTUALIZADO_DESDE: res.data.ACTUALIZADO_DESDE,
		                FECHA_ELIMINACION: res.data.FECHA_ELIMINACION,
		            })
		            this.$toasted.show('La publicación ha sido actualizada.')
				}).catch((err) =>{
					//
				})
			},

			editarPublicacion(publicacion){
				this.formEdit.codigo = publicacion.CODIGO_PUBLICACION
				this.formEdit.descripcion = publicacion.DESCRIPCION_PUBLICACION
				this.formEdit.tipo = publicacion.TIPO
				this.formEdit.fecha_inicial = publicacion.FECHA_INI
				this.formEdit.fecha_final = publicacion.FECHA_FIN
				this.formEdit.estado = publicacion.ESTATUS
				this.formEdit.disabled = true
				this.formEdit.loading = false
				this.formEdit.file = ''
				this.formEdit.image = publicacion.IMG_URL
			},

			infiniteHandler($state){
	        	axios.get('/api/publicaciones', {
    				url: this.publicaciones.next_page_url
    			})
    			.then(response => {
    				if (this.publicaciones.current_page+1 == response.data.current_page) {
		                this.publicaciones = {
		                    current_page: response.data.current_page,
		                    data: this.publicaciones.data.concat(response.data.data),
		                    first_page_url: response.data.first_page_url,
		                    from: response.data.from,
		                    last_page: response.data.last_page,
		                    last_page_url: response.data.last_page_url,
		                    next_page_url: response.data.next_page_url,
		                    path: response.data.path,
		                    per_page: response.data.per_page,
		                    prev_page_url: response.data.prev_page_url,
		                    to: response.data.to,
		                    total: response.data.total
		                }
		            }else{
		                this.publicaciones = response.data
		            }

    				if(response.data.length > 0 && this.publicaciones.next_page_url != null){
    					$state.loaded()
    				}else{
    					$state.complete()
    				}
    			})
	        },

	        clearFields(){
	        	this.loading = false
				this.disabled = true
				this.fecha_inicial = ''
				this.fecha_final = ''
				this.modalEdit = false
				this.form.descripcion = ''
				this.form.tipo = 3
				this.form.fecha_inicial = ''
				this.form.fecha_final = ''
				this.form.file = ''
				this.form.image = ''

				this.formEdit.codigo = ''
				this.formEdit.tipo = ''
				this.formEdit.descripcion = ''
				this.formEdit.fecha_inicial = ''
				this.formEdit.fecha_final = ''
				this.formEdit.estado = ''
				this.formEdit.disabled = true
				this.formEdit.loading = false
				this.formEdit.file = ''
				this.formEdit.image = ''
	        }
	    },
	    computed: {
	    	publicacionesDisp(){
	    		return this.publicaciones.data || []
	    	},

	    	validateFechas(){
	    		if (this.form.fecha_inicial || this.form.fecha_final) {
	    			return true
	    		}
	    		return false
	    	},

	    	validateFechasEdit(){
	    		if (this.formEdit.fecha_inicial || this.formEdit.fecha_final) {
	    			return true
	    		}
	    		return false
	    	},

	    	descripcion(){
	        	return this.form.descripcion
	        },

	        descripcionEdit(){
	        	return this.formEdit.descripcion
	        },

	        hasAdmin(){
	        	if (crm.role == 'A' || crm.role == 'U') { return true}
	        	return false
	        },

	        hasPrestamos(){
	        	return crm.tipoCrm.is_prestamos
	        }
	    },

	    watch: {
	    	descripcion(val){
	    		if (val.length>0) {
	    			this.disabled = false
	    		}else{
	    			this.disabled = true
	    		}
	    	},

	    	descripcionEdit(val){
	    		if (val.length>0) {
	    			this.formEdit.disabled = false
	    		}else{
	    			this.formEdit.disabled = true
	    		}
	    	}
	    }
	}
</script>